module.exports = __webpack_public_path__ + "img/icon_buzz_lines_right_yellow.b07e61c7.svg";